
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const EditProfile = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <h1 className="font-poppins font-bold text-4xl mb-4">Edit Profile</h1>
          <p className="font-inter text-xl text-gray-600">
            Update your profile information
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="font-poppins text-2xl">Edit Profile</CardTitle>
            <CardDescription className="font-inter">
              Make changes to your profile
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-center py-8 text-gray-500 font-inter">
              Profile editing form will be displayed here.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EditProfile;
